import React, { useState } from 'react';
import styled from 'styled-components';
import AuthInputComponent from '../../components/AuthInputComponent';
import AuthFooter from '../../components/auth/AuthFooter';
import {
  FindPasswordPageUrl,
  LoginPageUrl,
  ResultIdPageUrl,
} from '../../url/poenUrl';
import { useNavigate } from 'react-router';
import AuthBackgroundLogo from '../../components/auth/AuthBackgroundLogo';
import AuthLogo from '../../components/auth/AuthLogo';
import AuthService from '../../api/service/auth/AuthService';
import PermissionRedirect from '../../components/PermissionRedirect';

const Container = styled.div`
  padding: 20px;
  font-family: 'Pretendard', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #fff;
  position: relative;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
`;

const FindIdForm = styled.div`
  z-index: 1;
  width: 100%;
  padding: 20px;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;

const Button = styled.button`
  width: 100%;
  padding: 12px;
  margin-top: 10px;
  border: none;
  font-size: 16px;
  color: white;
  cursor: pointer;

  background-color: ${({ theme }) => theme.colors.mainColor};

  &:hover {
    background-color: ${({ theme }) => theme.colors.hoverColor};
  }
`;

const FindIdPage = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const response = await AuthService.identifierFind({ name, email });
      //console.log('아이디 찾기 성공:', response);

      // 응답 데이터에 name과 email을 추가
      const data = {
        ...response.data,
        name, // 이름 추가
        email, // 이메일 추가
      };

      // 서버로부터 성공적으로 응답을 받으면 아이디 결과 페이지로 이동
      navigate(ResultIdPageUrl, {
        state: data, // 응답 데이터와 이름/이메일 포함
      });
    } catch (err) {
      console.error('아이디 찾기 실패:', err);
      alert(err);
    }
  };

  return (
    <Container>
      <PermissionRedirect />
      <AuthLogo />
      <Title>아이디 찾기</Title>
      <FindIdForm>
        <Form onSubmit={handleSubmit}>
          <AuthInputComponent
            type="text"
            placeholder="이름을 입력해 주세요"
            value={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setName(e.target.value)
            }
          />
          <AuthInputComponent
            type="email"
            placeholder="이메일주소를 입력해 주세요"
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setEmail(e.target.value)
            }
          />
          <Button type="submit">확인</Button>
        </Form>
        <AuthFooter
          firstUrl={LoginPageUrl}
          secondUrl={FindPasswordPageUrl}
          findIdText="로그인"
          findPasswordText="비밀번호 찾기"
        />
      </FindIdForm>

      <AuthBackgroundLogo />
    </Container>
  );
};

export default FindIdPage;
